import script from "./HotScenicBar.vue?vue&type=script&setup=true&lang=js"
export * from "./HotScenicBar.vue?vue&type=script&setup=true&lang=js"

import "./HotScenicBar.vue?vue&type=style&index=0&id=2a9dbcd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a9dbcd2"]])

export default __exports__